// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-container {
  position: relative;
}

.tooltip {
  position: absolute;
  top: 24px;
  color: white;
  padding: 12px;
  width: -moz-fit-content;
  width: fit-content;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  background-color: rgb(0, 0, 0);
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/screens/listOfEmployees/ListOfEmployeesTooltip.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EAAA,kBAAA;EAGA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAEA,8BAAA;EACA,WAAA;AAFJ","sourcesContent":[".tooltip-container{\n    position: relative;\n}\n\n.tooltip{ \n    position: absolute;\n    top: 24px;\n    color: white;\n    padding: 12px;\n    width: fit-content;\n\n\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n\n    background-color : rgb(0,0,0);\n    z-index: 10;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
